export const LOCAL_ADD_INSTRUMENTATION = 'LOCAL_ADD_INSTRUMENTATION';
export const LOCAL_SET_INSTRUMENTATIONS = 'LOCAL_SET_INSTRUMENTATIONS';
export const LOCAL_DELETE_INSTRUMENTATION = 'LOCAL_DELETE_INSTRUMENTATION';
export const LOCAL_UPDATE_INSTRUMENTATION = 'LOCAL_UPDATE_INSTRUMENTATION';
export const LOCAL_SET_INSTRUMENTATIONS_TASK =
  'LOCAL_SET_INSTRUMENTATIONS_TASK';
export const LOCAL_SET_INSTRUMENTATION_HISTORY =
  'LOCAL_SET_INSTRUMENTATION_HISTORY';
export const LOCAL_SET_INSTRUMENTATION_JOB_HISTORY =
  'LOCAL_SET_INSTRUMENTATION_JOB_HISTORY';
export const LOCAL_SET_COUNT_BY_SITE_ID = 'LOCAL_SET_COUNT_BY_SITE_ID';
